(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header__general--utility"] && !Shopify.designMode) return;
  try {
    (function(){
  function setup(){
    document.querySelectorAll('.header__utility .minicart__label .item__count').forEach(function(badge){
      if(badge.dataset.igBadgeReady)return;
      badge.dataset.igBadgeReady='true';
      function sync(){badge.dataset.igEmpty=String(!parseInt(badge.textContent,10));}
      sync();
      new MutationObserver(sync).observe(badge,{childList:true,characterData:true,subtree:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ig-product-ip-report"] && !Shopify.designMode) return;
  try {
    (function(){
  function initialize(){
    document.querySelectorAll('[data-ig-ip-open]').forEach(function(trigger){
      if(trigger.dataset.igIpReady)return;
      trigger.dataset.igIpReady='1';
      var dialog=document.getElementById(trigger.dataset.igIpOpen);
      if(!dialog)return;
      var supporting=dialog.querySelector('[data-ig-ip-supporting]');
      if(supporting){
        var list=supporting.querySelector('[data-ig-ip-urls]');
        var template=supporting.querySelector('[data-ig-ip-url-template]');
        var addButton=supporting.querySelector('[data-ig-ip-add-url]');
        var status=supporting.querySelector('[data-ig-ip-url-status]');
        var nextUrl=1;
        function message(text,number){return text.replace('__number__',String(number));}
        addButton.addEventListener('click',function(){
          var number=++nextUrl;
          var row=template.content.firstElementChild.cloneNode(true);
          var input=row.querySelector('input');
          var label=row.querySelector('[data-ig-ip-url-label]');
          var remove=row.querySelector('[data-ig-ip-remove-url]');
          input.id=dialog.querySelector('form').id+'-support-'+number;
          input.name='contact[Supporting URL '+number+']';
          label.htmlFor=input.id;
          label.textContent=message(supporting.dataset.label,number);
          remove.setAttribute('aria-label',message(supporting.dataset.removeLabel,number));
          remove.addEventListener('click',function(){
            var previous=row.previousElementSibling;
            row.remove();
            status.textContent=message(supporting.dataset.removed,number);
            (previous?previous.querySelector('input'):addButton).focus();
          });
          list.appendChild(row);
          status.textContent=message(supporting.dataset.added,number);
          input.focus();
        });
      }
      var previousOverflow='';
      function open(){
        if(dialog.open)return;
        previousOverflow=document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow='hidden';
        var target=dialog.querySelector('[data-ig-ip-result]')||dialog.querySelector('h2');
        target.focus({preventScroll:true});
      }
      trigger.addEventListener('click',open);
      dialog.querySelectorAll('[data-ig-ip-close]').forEach(function(button){button.addEventListener('click',function(){dialog.close();});});
      dialog.addEventListener('click',function(event){
        if(event.target!==dialog)return;
        var r=dialog.getBoundingClientRect();
        if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
      });
      dialog.addEventListener('close',function(){
        document.documentElement.style.overflow=previousOverflow;
        trigger.focus({preventScroll:true});
      });
      if(dialog.querySelector('[data-ig-ip-result]'))open();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
